export const SearchExamples = {
  goToBibleRef: {
    title: "goToBibleRef",
    keys: ["revelation612", "rev612"]
  },
  goToBookPage: {
    title: "goToBookPage",
    keys: ["education", "education57", "ed57"]
  },
  wordsWithinBookEd: {
    title: "wordsWithinBookEd",
    keys: ["edGreatestWant", "educationGreatestWant"]
  },
  phraseInBook: {
    title: "phraseInBook",
    keys: ["edPhrase", "educationPhrase"]
  },
  search_topic: {
    title: "search_topic",
    keys: ["greatestWantQuotes"]
  },
  wildCardSearch: {
    title: "wildCardSearch",
    keys: ["just"]
  },
  proximityMatch: {
    title: "proximityMatch",
    keys: ["faithSight"]
  },
  minimumMatching: {
    title: "minimumMatching",
    keys: ["loveJoy"]
  },
  orderedSearch: {
    title: "orderedSearch",
    keys: ["godStr"]
  },
  answers: {
    title: "ansToQuest",
    keys: ["ansToQuestExample"]
  },
};

export const SearchPanelTabs = {
  RESULTS: "RESULTS",
  RELATED: "RELATED",
  FEATURED: "FEATURED",
  STUDY: "STUDY"
};

export const SEARH_PANEL_TAB_ITEMS = [
  {
    id: SearchPanelTabs.RESULTS,
    label: "results"
  },
  {
    id: SearchPanelTabs.RELATED,
    label: "related"
  },
  {
    id: SearchPanelTabs.FEATURED,
    label: "featured"
  },
  {
    id: SearchPanelTabs.STUDY,
    label: "study"
  }
];
